import React, { useState, useEffect } from "react";


const Geolocation = ({onCountry}) => {

  const [userCountry, setUserCountry] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await new Promise((resolve, reject) => {
          navigator.geolocation.getCurrentPosition(resolve, reject);
        });
    
        const response = await fetch(
          `https://api.ipregistry.co/?key=ssiezb4yfktxpm6x`
        );
        const data = await response.json();
        const country = data.location.country.name;
       
        setUserCountry(country);
        onCountry(true,country)
      } catch (error) {
      }
    };

    fetchData();
   
  }, []);


};

export default Geolocation;
